<template>
  <div class="stream-item">
      <van-row align="center" type="flex" justify="space-between">
        <van-col :span="isH5 ? 6 : 4">
            <router-link rel="nofollow" :to="{path:'/details/',query:{apkpkg:item.apkpkg}}">
                <van-image
                :radius="isH5? 7 : 24"
                lazy-load
                :src="item.apkicon"
                />
            </router-link>
        </van-col>
        <van-col :span="isH5 ? 12 : 16">
            <router-link :to="{path:'/details/',query:{apkpkg:item.apkpkg}}">
                <h3 class="gamename">{{item.apkname}}</h3>
            </router-link>
            <router-link rel="nofollow" :to="{path:'/details/',query:{apkpkg:item.apkpkg}}">
                <div class="star">
                    <van-rate
                    v-model="item.star"
                    allow-half
                    readonly
                    color="#ffd21e"
                    void-icon="star"
                    void-color="#eee"
                    size="12"
                    />
                    <span class="starnum">{{item.star}}</span>
                </div>
            </router-link>
        </van-col>
        <van-col :span="isH5 ? 6 : 4">
            <router-link rel="nofollow" :to="{path:'/details/',query:{apkpkg:item.apkpkg}}">
                <van-button type="default" class="detailbtn" size="small " text="Details"></van-button>
            </router-link>
        </van-col>
    </van-row>
  </div>
</template>
<script>
import resizeMixin from '@/mixins/resizeMixin'
export default {
    mixins: [resizeMixin],
    props:{
        type:Object,
        item:{
            apkpkg:String,
        }
    },
    data() {
        return {
        }
    },
    created() {

    }
}
</script>
<style lang="scss" scoped>
@media only screen and (min-width: 750px) {
    .stream-item {    
        display: flex;
        flex-direction: column;
        height: 100%;
        &:hover {
            background-color: rgba(74, 144, 226, 0.1)
        }
        .van-col--16{
            height: 90px!important;
            display: flex;
            justify-content: space-around;
            flex-direction: column;
        }
        .van-image {
            vertical-align: text-bottom;
        }
    }
}
.stream-item {
    margin: 20px 0;
    .van-col {
        min-height: 50px!important;
        .van-image {
            margin-top: 4px;
            width: 75%;
            border-radius: 8px;
        }
        .detailbtn {
            width: 63px;
            height: 28px;
            background-color: #4A90E2;
            border-radius: 4px;
            font-size: 12px;
            color: white;
            line-height: 28px;
            margin-top: 50%;
            transform: translateY(-65%);
            .van-button__text {
                margin-left: auto;
                margin-right: auto;
                display: block;
                width: 100%;
            }
        }
        .gamename {
            font-size: 14px;
            color: #2F3234;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            text-align: left;
        }
        .star {
            text-align: left;
            line-height: 18px;
            margin-top: 6px;
            .starnum {
                font-size: 12px;
                line-height:18px;
                color: #999999;
                vertical-align: top;
                margin-left:5px;
            }
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/components/onegame.vue